import Image from "next/image";
import { useState } from "react";
import { GrNext, GrPrevious } from "react-icons/gr";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import {
  DefaultCarPageComponentProps,
  PicsSwipperProps,
} from "@/app/interface/components";

const PicsSwipper = ({ externalImages, internalImages }: PicsSwipperProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [picsType, setPicsType] = useState(0);
  function SampleNextArrow(props: any) {
    const { onClick } = props;
    return (
      <div
        className={
          " absolute h-fit bg-gray-500 text-neutral-100 p-2 px-4 w-fit rounded-full inset-0 mt-auto mx-auto lg:mr-80 mr-10 -mb-16"
        }
        onClick={onClick}
      >
        <GrNext size={20} />
      </div>
    );
  }

  function SamplePrevArrow(props: any) {
    const { onClick } = props;
    return (
      <div
        className={
          " absolute z-20 bg-gray-500 text-neutral-100 p-2 px-4 w-fit h-fit rounded-full inset-0 mx-auto mt-auto lg:ml-80 ml-10 -mb-16"
        }
        onClick={onClick}
      >
        <GrPrevious size={20} />
      </div>
    );
  }
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setCurrentIndex(newIndex);
    },
    customPaging: (index: number) => {
      return (
        <div
          key={"paging.cars.pics" + index}
          className={`w-6 h-2 cursor-pointer relative max-sm:-bottom-2 -bottom-10 ${
            currentIndex === index ? "bg-gray-500" : "bg-gray-300"
          }`}
        ></div>
      );
    },
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <section id="galeria" className=" pt-20 w-full  bg-white flex">
      <div className="pb-20 w-full mx-auto max-w-[1140px] flex bg-white flex-col items-center overflow-hidden">
        <h1 className="text-3xl  text-black  max-md:max-w-full text-center">
          Galeria de fotos
        </h1>
        <div className="text-neutral-400 flex mt-3">
          <p
            className={`px-5 py-3 cursor-pointer border-b-2 ${
              picsType == 0 && "border-neutral-700 text-neutral-700"
            }`}
            onClick={() => setPicsType(0)}
          >
            Interior
          </p>
          <p
            className={`px-5 py-3 cursor-pointer border-b-2 ${
              picsType == 1 && "border-neutral-700 text-neutral-700"
            }`}
            onClick={() => setPicsType(1)}
          >
            Exterior
          </p>
        </div>
        <div className=" w-10/12 py-8">
          <Slider {...settings}>
            {picsType == 0
              ? internalImages?.map((card, i) => (
                  <div key={`car-image-${i}`}>
                    <Image
                      width={400}
                      height={400}
                      loading="lazy"
                      src={card}
                      alt="Car Picture"
                      className="object-contain w-full aspect-[1.62] mt-2"
                    />
                  </div>
                ))
              : externalImages?.map((card, i) => (
                  <div key={`car-image-${i}`}>
                    <Image
                      width={400}
                      height={400}
                      loading="lazy"
                      src={card}
                      alt="Car Picture"
                      className="object-contain w-full aspect-[1.62] mt-2"
                    />
                  </div>
                ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default PicsSwipper;
